import {useCallback, useEffect, useReducer, useState} from 'react';

import {State} from '_/utilities';

import {setError, setLoading, setResult} from './actions';
import {initialState, reducer} from './reducer';

interface Result<T> {
  error: Error | null;
  result: T | null;
  status: State;
  update: () => void;
}

/**
 * @deprecated instead fetch data normally, remove function as soon as SelectBox gets removed
 */
function usePromise<ResultType>(
  promiseGenerator: () => {promise?: Promise<ResultType>; abort?: () => void},
  dependencies: readonly any[]
): Result<ResultType> {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [updateIssueTime, setUpdateIssueTime] = useState(new Date());
  // deprectaed so dependency list has not been checked
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const persistencePromiseGenerator = useCallback(
    promiseGenerator,
    dependencies
  );
  const update = useCallback(() => setUpdateIssueTime(new Date()), []);

  useEffect(() => {
    const {promise, abort} = persistencePromiseGenerator();
    let aborted = false;

    async function waitPromise(): Promise<void> {
      dispatch(setLoading());

      try {
        const result = await promise;

        if (!aborted) {
          dispatch(setResult(result));
        }
      } catch (error) {
        if (error instanceof Error) {
          // istanbul ignore else
          if (process.env.NODE_ENV === 'test') {
            // eslint-disable-next-line no-console
            console.error(error, error.stack);
          }

          if (!aborted) {
            dispatch(setError(error));
          }
        }
      }
    }

    if (promise !== undefined) {
      waitPromise();
    }

    return (): void => {
      aborted = true;
      abort?.();
    };
  }, [persistencePromiseGenerator, updateIssueTime]);

  return {...state, update};
}

/**
 * @deprecated instead fetch data normally, remove function as soon as SelectBox gets removed
 */
export default usePromise;
